module.exports = __webpack_public_path__ + "static/media/faceOverlayDesktop.14ada52c.svg";